import graphqlClient from '../../api/axios_interceptor';

import {
    FETCH_INVOICES,
    ADD_INVOICE,
    BULK_ADD_INVOICES,
    UPDATE_INVOICE,
    FETCH_SINGLE_INVOICE,
    DELETE_INVOICES,
    CREATE_PROPERTY_INVOICES,
    CREATE_RECURRING_BILLS_INVOICES,
    CALCULATE_BULK_INVOICES,
    CREATE_BULK_INVOICES
} from '../actions/actionTypes';
import { updateActionErrors } from './updateErrors';

import {
    getInvoicesQuery,
    addInvoiceMutation,
    bulkAddInvoicesMutation,
    updateInvoiceMutation,
    deleteInvoicesMutation,
    getSingleInvoiceQuery,
    createPropertyInvoicesMutation,
    createRecurringBillsInvoicesMutation,
    calculateBulkInvoicesMutation,
    createBulkInvoicesMutation
} from "../../api/graphql/queries/invoices";
import {convertDateToUserLocalDate} from "../../utils/general"

export const parseInvoice = (invoice) => (
    {
    invoiceId: invoice.id,
    combineWithOtherInvoices: invoice.combineWithOtherInvoices,
    tenantId: invoice.tenantDetails? invoice.tenantDetails.tenantId: "",
    tenant: invoice.tenantDetails? invoice.tenantDetails: {},
    amount: invoice.amount,
    amountPaid: invoice.paid,
    status: invoice.status,
    description: invoice.description,
    teamMemberId: invoice.createdBy ? invoice.createdBy.id : "",
    invoiceDate: convertDateToUserLocalDate(invoice.invoiceDate),
    lastUpdated: invoice.lastUpdated,
    item: invoice.invoiceItems.map(item=> item.itemName).join(", "),
    invoiceItems: invoice.invoiceItems,
    message: invoice.message ? invoice.message.id : ""
});


export const fetchInvoicesMiddleware = async (action) => {
    try {
        let invoices = {};
        const query = getInvoicesQuery(action.payload);
        await graphqlClient({
            data: {
                query
            },
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else {
                invoices = queryResult.data.data.invoices.invoices.map(parseInvoice);
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                        invoices
                    },
                    offset: queryResult.data.data.invoices.next,
                    summary: queryResult.data.data.invoices.summary
                });
            }
        });

    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

export const fetchSingleInvoiceMiddleware = async (action) => {
    try {
        let invoice = {};
        const query = getSingleInvoiceQuery(action.payload.invoiceId);
        await graphqlClient({
            data: {
                query
            },
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else {
            invoice = parseInvoice(queryResult.data.data.invoice);
            action = ({
                ...action,
                payload: {
                    ...action.payload,
                    invoice
                }
            });
        }
        });

    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const addInvoiceMiddleware = async (action) => {
    let payload = action.payload;
    try {
        const invoice = payload.invoice;
        let query = addInvoiceMutation(invoice.tenantId, invoice.invoiceItems,
            invoice.description, invoice.status, invoice.invoiceDate,
            invoice.combineWithOtherInvoices
        );
        await graphqlClient({
            data: {
                query: query
            },
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);

            } else if (queryResult.data.data.addInvoice.errorMessage) {
                action = updateActionErrors(action, queryResult.data.data.addInvoice.errorMessage);
            }
            else {
                action = ({
                    ...action,
                    payload: {
                        ...payload,
                        invoice: parseInvoice(queryResult.data.data.addInvoice.invoice)
                    }
                });
            }
        })
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const bulkAddInvoicesMiddleware = async (action) => {
    let payload = action.payload;
    try {
        let query = bulkAddInvoicesMutation(payload.invoices);
        await graphqlClient({
            data: {
                query: query
            },
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);

            } else if (queryResult.data.data.bulkAddInvoices.errorMessage) {
                action = updateActionErrors(action, queryResult.data.data.bulkAddInvoices.errorMessage);
            }
            else {
                action = ({
                    ...action,
                    payload: {
                        ...payload,
                        newInvoices: queryResult.data.data.bulkAddInvoices.invoices.map(parseInvoice)
                    }
                });
            }
        })
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const createPropertyInvoicesMiddleware = async (action) => {
    let payload = action.payload;
    try {
        let invoices = {};
        let query = createPropertyInvoicesMutation(payload.propertyIds);
        await graphqlClient({
            data: {
                query: query
            },
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);

            } else if (queryResult.data.data.createPropertyInvoices.errorMessage) {
                action = updateActionErrors(action, queryResult.data.data.createPropertyInvoices.errorMessage);
            }
            else {
                let returnedInvoices = queryResult.data.data.createPropertyInvoices.newlyCreatedMonthInvoices;

                invoices = returnedInvoices ? returnedInvoices.map(parseInvoice) : [];
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                        invoices
                    }
                });
            }
        })
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const createOtherRecurringBillsMiddleware = async (action) => {
    let payload = action.payload;
    try{
        let invoices = {};
        let query = createRecurringBillsInvoicesMutation(payload.propertyIds, payload.tenantIds, payload.unitIds)
        await graphqlClient({
            data: {
                query: query
            }
        }).then((queryResult) => {
            if(queryResult.data.errors){
                action = updateActionErrors(action, queryResult.data.errors)
            }else if(queryResult.data.data.createOtherRecurringBillsInvoices.errorMessage){
                action = updateActionErrors(action, queryResult.data.data.createOtherRecurringBillsInvoices.errorMessage)
            }else{
                let createdInvoices = queryResult.data.data.createOtherRecurringBillsInvoices.newlyCreatedMonthInvoices;
                invoices = createdInvoices ? createdInvoices.map(parseInvoice): [];
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                        invoices
                    }
                })
            }
        })

    }catch (error){
        console.log(error)
        action = updateActionErrors(action, error)
    }
    return action
}

const updateInvoiceMiddleware = async (action) => {
    try {
        let payload = action.payload;
        let invoice = payload.invoice;
        let query = updateInvoiceMutation(invoice.invoiceId, {
            invoiceItems: invoice.invoiceItems,
            description: invoice.description,
            tenantId: invoice.tenantId,
            status: invoice.status,
            invoiceDate: invoice.invoiceDate
        });
        await graphqlClient({
            data: {
                query: query
            },
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);

            } else if (queryResult.data.data.updateInvoice.errorMessage) {
                action = updateActionErrors(action, queryResult.data.data.updateInvoice.errorMessage);
            }
            else {
                action = ({
                    ...action,
                    payload: {
                        ...payload,
                        invoice: parseInvoice(queryResult.data.data.updateInvoice.invoice)
                    }
                });
            }
        })
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const deleteInvoicesMiddleware = async action => {
    try {
        let payload = action.payload;
        await graphqlClient({
            data: {
                query: deleteInvoicesMutation(payload.invoiceIds)
            }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else if (queryResult.data.data.deleteInvoice.errorMessage) {
                action = updateActionErrors(action, queryResult.data.data.deleteInvoice.errorMessage);
            }
            else {
                action = ({
                    ...action,
                    payload: {
                        ...payload,
                        success: queryResult.data.data.deleteInvoice.success
                    }
                });
            }
        })
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const calculateBulkInvoicesMiddleware = async action => {
    try {
        const { propertyIds, invoiceDate, invoiceItems } = action.payload;
        const query = calculateBulkInvoicesMutation(propertyIds, invoiceDate, invoiceItems);
        let calculated = [];
        let message = '';
        await graphqlClient({ data: { query } }).then((result) => {
            if (result.data.errors) {
                action = updateActionErrors(action, result.data.errors);
            } else {
                const response = result.data.data.calculateBulkInvoices;
                if (!response.success) {
                    action = updateActionErrors(action, response.message || 'Failed to calculate invoices');
                } else {
                    calculated = response.calculatedInvoices || [];
                    message = response.message || '';
                    action = {
                        ...action,
                        payload: { ...action.payload, calculatedInvoices: calculated, message }
                    };
                }
            }
        });
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const createBulkInvoicesMiddleware = async (action) => {
    let payload = action.payload;
    try {
        const query = createBulkInvoicesMutation(payload.invoiceInputs);
        await graphqlClient({ data: { query } }).then((result) => {
            if (result.data.errors) {
                action = updateActionErrors(action, result.data.errors);
            } else {
                const response = result.data.data.createBulkInvoices;
                if (!response.success) {
                    action = updateActionErrors(action, response.message || 'Failed to create invoices');
                } else {
                    const newInvoices = (response.invoices || []).map(parseInvoice);
                    action = {
                        ...action,
                        payload: { ...payload, newInvoices, message: response.message }
                    };
                }
            }
        });
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

export const invoicesMiddleware = storeAPI => next => async action => {
    switch (action.type) {
        case FETCH_INVOICES:
            action = await fetchInvoicesMiddleware(action);
            break;
        case FETCH_SINGLE_INVOICE:
            action = await fetchSingleInvoiceMiddleware(action);
            break;
        case ADD_INVOICE:
            action = await addInvoiceMiddleware(action);
            break;
        case BULK_ADD_INVOICES:
            action = await bulkAddInvoicesMiddleware(action);
            break;
        case CREATE_PROPERTY_INVOICES:
            action = await createPropertyInvoicesMiddleware(action);
            break;
        case CREATE_RECURRING_BILLS_INVOICES:
            action = await createOtherRecurringBillsMiddleware(action);
            break;
        case UPDATE_INVOICE:
            action = await updateInvoiceMiddleware(action);
            break;
        case DELETE_INVOICES:
            action = await deleteInvoicesMiddleware(action);
            break;
        case CALCULATE_BULK_INVOICES:
            action = await calculateBulkInvoicesMiddleware(action);
            break;
        case CREATE_BULK_INVOICES:
            action = await createBulkInvoicesMiddleware(action);
            break;
        default:
            break;
    }
    return next(action);
}
